import { PAGES } from "@dune/types";
import { BuilderToSubmissionFormData } from "@dune/types";
import { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateBuilderParticipant } from "../../../../api/mutations/constructionSiteSubmission.mutations";
import { BuilderToSubmissionForm } from "../../../../component/constructionSites/submission/participants/BuilderToSubmissionForm";
import PageLayoutWithTabs from "../../../../component/layout/PageLayoutWithTabs";
import { useEntityPanelSync } from "../../../../hooks/useEntityPanelSync";
import { useBuilderToSubmissionForm } from "../../../../hooks/useParticipantToSubmissionForm";

export const EditBuilderToSubmissionPage = () => {
	const navigate = useNavigate();
	const { constructionSiteId, participantId } = useParams<{
		constructionSiteId: string;
		participantId: string;
	}>();

	const updateBuilderMutation = useUpdateBuilderParticipant(
		constructionSiteId ? Number(constructionSiteId) : 0,
		participantId ? Number(participantId) : 0,
	);

	const onSubmit = (data: BuilderToSubmissionFormData) => {
		updateBuilderMutation.mutate(data, {
			onSuccess: () => {
				if (constructionSiteId) {
					navigate(PAGES.PROJECTS.submission.withParams(constructionSiteId, 4));
				}
			},
		});
	};

	const onCancel = () => {
		if (constructionSiteId) {
			navigate(PAGES.PROJECTS.submission.withParams(constructionSiteId, 4));
		}
	};

	const { form, handleSubmit } = useBuilderToSubmissionForm({
		mode: "update",
		onSubmit,
		constructionSiteId: constructionSiteId
			? Number(constructionSiteId)
			: undefined,
		participantId: participantId ? Number(participantId) : undefined,
	});

	useEntityPanelSync({
		entityType: "CONSTRUCTION_SITE",
		entityId: constructionSiteId ? Number(constructionSiteId) : 0,
	});

	useEffect(() => {
		if (!constructionSiteId || !participantId) {
			navigate(PAGES.PROJECTS.index);
		}
	}, [constructionSiteId, participantId, navigate]);

	if (!constructionSiteId || !participantId) {
		return null;
	}

	return (
		<PageLayoutWithTabs title="Modifier un réalisateur">
			<FormProvider {...form}>
				<form onSubmit={handleSubmit}>
					<BuilderToSubmissionForm
						constructionSiteId={Number(constructionSiteId)}
						onSubmit={handleSubmit}
						onCancel={onCancel}
						isSubmitting={updateBuilderMutation.isPending}
					/>
				</form>
			</FormProvider>
		</PageLayoutWithTabs>
	);
};
